import { LEGACY_POSIX_TIMEZONES } from "@/constants/legacy-timezones";

/**
 * The IANA zone to format a stored timezone code in, so a POSIX-style code such as `EST5EDT` keeps
 * its zone abbreviation (`EDT`) whatever tzdata the runtime ships.
 *
 * @param timezoneCode A timezone code from the timezone CodeSystem.
 * @returns The city zone for a POSIX-style US code, or the code unchanged.
 */
export function toFormattingTimezone(timezoneCode: string): string {
  return LEGACY_POSIX_TIMEZONES[timezoneCode] ?? timezoneCode;
}
